import * as React from "react";
import * as auth from "../appAuth/auth-provider";
import { CheckAccessControl } from "../services/AccessControlApis";

const AuthContext = React.createContext();
AuthContext.displayName = "AuthContext";

function AuthProvider(props) {
  const [user, setUser] = React.useState(null);
  const [accessPermission, setaccessPermission] = React.useState("NYU-IT");
  const [unauthorizedError, setUnauthorizedError] = React.useState(null); // received 403 from server
  // set location as dependency to re-run useEffect() testing expire time
  // let location = useLocation();

  React.useEffect(() => {
    const userInStorage = auth.getUserFromSessionStorage();
    if (userInStorage) {
      if (new Date().getTime() < userInStorage["expiry"]) {
        CheckAccessControl(setaccessPermission);
        setUser(userInStorage);
      } else {
        auth.logout();
      }
    }
  }, []);

  const login = React.useCallback(
    () =>
      auth
        .authenticate()
        .then((authUser) => {
          setUser(authUser);
        })
        .catch((err) => {
          console.error(err)
          setUnauthorizedError(err)
        } 
          ),
    [setUser]
  );

  const logout = React.useCallback(() => {
    auth.logout();
  }, []);

  const value = React.useMemo(
    () => ({ user, login, logout, accessPermission, unauthorizedError  }),
    [login, logout, user, accessPermission, unauthorizedError]
  );
  return <AuthContext.Provider value={value} {...props} />;
}

function useAuth() {
  const context = React.useContext(AuthContext);

  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`);
  }
  return context;
}

export { AuthProvider, useAuth };
